module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAMlJREFUOI2l0ztOQkEUBuBB4DZAR+PiNDGwAQoSKW6Jja/OR0WHpa7CBbAHEgzRoIkNMflsTmGIzZ2Z8iT/lz85c1Jq8NDBFKsmuUOkwjk+8ZCLtFFjjzu0c6Ea37hGJxe5xA43qHKAboQ3uEA3BxngEWvMGgOBDAPZYJKFBLTAD86a5I7+mb2nlPYppePsNtGohzm2uCrFqtjUG26zP+AfsI7N3aNXik3wgScMSrExvrBEvxQbxb09F2Fo4SS2+VLUKsBTvB7OfwEVXusaI/3ZMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/auth/left_arrow.png
// module id = 161
// module chunks = 453